import Vue from "vue";
import VueI18n from "vue-i18n";
import { baseMessages, Locale } from "@/plugins/i18n/types";

Vue.use(VueI18n);

export const i18n = new VueI18n({
  fallbackLocale: Locale.EN,
  messages: baseMessages
});
